import React, { useState, useEffect } from 'react';
import api from '../lib/api';
import { Card, CardContent, CardHeader, CardTitle } from '../components/ui/card';
import { Label } from '../components/ui/label';
import { Input } from '../components/ui/input';
import { Button } from '../components/ui/button';
import { useAuth } from '../context/AuthContext';
import { Target, Save } from 'lucide-react';
import { toast } from 'sonner';

export default function Settings() {
  const { user, updateUser } = useAuth();
  const [weeklyGoal, setWeeklyGoal] = useState(300);
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (user) {
      setWeeklyGoal(user.weekly_goal || 300);
    }
  }, [user]);

  const handleSaveGoal = async () => {
    setLoading(true);
    try {
      const response = await api.patch('/settings/goal', { weekly_goal: parseInt(weeklyGoal) });
      updateUser({ weekly_goal: response.data.weekly_goal });
      toast.success('Meta atualizada com sucesso!');
    } catch (error) {
      console.error('Error updating goal:', error);
      toast.error('Erro ao atualizar meta');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="page-container" data-testid="settings-page">
      <div className="max-w-md mx-auto px-6 py-8">
        <div className="mb-8">
          <h1 className="text-4xl font-bold tracking-tight mb-2">Configurações</h1>
          <p className="text-lg text-muted-foreground">Personalize suas metas de estudo</p>
        </div>

        <Card className="shadow-sm" data-testid="goal-settings-card">
          <CardHeader>
            <CardTitle className="flex items-center gap-2 text-xl">
              <Target className="w-5 h-5 text-brand" />
              Meta Semanal de Questões
            </CardTitle>
          </CardHeader>
          <CardContent className="space-y-6">
            <div className="space-y-2">
              <Label htmlFor="weeklyGoal">Número de questões por semana</Label>
              <Input
                id="weeklyGoal"
                type="number"
                min="1"
                step="50"
                value={weeklyGoal}
                onChange={(e) => setWeeklyGoal(e.target.value)}
                data-testid="weekly-goal-input"
              />
              <p className="text-sm text-muted-foreground">
                Recomendado: 300 questões/semana para iniciantes, 800 questões/semana para avançados
              </p>
            </div>

            <div className="flex gap-3">
              <Button 
                onClick={() => setWeeklyGoal(300)} 
                variant="outline" 
                className="flex-1"
                data-testid="preset-300-button"
              >
                300/semana
              </Button>
              <Button 
                onClick={() => setWeeklyGoal(800)} 
                variant="outline" 
                className="flex-1"
                data-testid="preset-800-button"
              >
                800/semana
              </Button>
            </div>

            <Button 
              onClick={handleSaveGoal} 
              disabled={loading} 
              className="w-full"
              data-testid="save-goal-button"
            >
              <Save className="w-4 h-4 mr-2" />
              {loading ? 'Salvando...' : 'Salvar Meta'}
            </Button>
          </CardContent>
        </Card>

        <Card className="mt-6 shadow-sm">
          <CardHeader>
            <CardTitle className="text-xl">Informações da Conta</CardTitle>
          </CardHeader>
          <CardContent className="space-y-4">
            <div>
              <Label className="text-sm text-muted-foreground">Nome</Label>
              <p className="font-medium">{user?.name}</p>
            </div>
            <div>
              <Label className="text-sm text-muted-foreground">E-mail</Label>
              <p className="font-medium">{user?.email}</p>
            </div>
          </CardContent>
        </Card>
      </div>
    </div>
  );
}
